export type FilterCategories = "app" | "category" | "status";

export type FilterOptions = {
    committedActive: boolean;
    stagedActive: boolean;
};

export type SubFilterObject = {
    [filter: string]: FilterOptions;
};

export type UniformFilterObject = {
    [key in FilterCategories]: SubFilterObject;
};
export type cardType = "sm" | "md" | "lg";
